export default {
  burncenter: 'bcqpBurnCenterId',
  type: 'applicationTypes',
  status: 'states',
  from: 'expiresFrom',
  to: 'expiresTo',
  isSample: 'isSample',
};
